import script from "./moreButton.vue?vue&type=script&lang=ts&setup=true&name=MoreButton"
export * from "./moreButton.vue?vue&type=script&lang=ts&setup=true&name=MoreButton"

import "./moreButton.vue?vue&type=style&index=0&id=483d3b27&lang=scss"

const __exports__ = script;

export default __exports__